<ul class="nav justify-content-end header">
  <li class="nav-item">
    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        [ngClass]="{ active: isThaiLanguage() }"
        (click)="toggleLanguage(lang.TH)"
      >
        ไทย
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        [ngClass]="{ active: !isThaiLanguage() }"
        (click)="toggleLanguage(lang.EN)"
      >
        ENG
      </button>
    </div>
  </li>
</ul>
